export enum AstSignMailHandoffStatus {
  INACTIVE = 'inactive',
  SHOWING = 'showing',
  TRANSFERRING = 'transferring',
  COMPLETE = 'complete',
}

export interface AstSignMailState {
  handoffStatus: AstSignMailHandoffStatus;
}
